/* window.BronteProgressBar: update(target, current), updateAll(current, scope), refresh(target), percent(el).
   Every update fires a bubbling `bronte:progress:update` CustomEvent with { current, percent }. */
(function () {
  if (window.BronteProgressBar) return;

  var BAR_SELECTOR = '[data-bronte-progress]';

  function num(value) {
    var parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  }

  function toElements(target) {
    if (!target) return [];
    if (typeof target === 'string') {
      var byId = document.querySelector('[data-bpb-id="' + target + '"]');
      if (byId) return [byId];
      return Array.prototype.slice.call(document.querySelectorAll(target));
    }
    if (target.nodeType === 1) return [target];
    if (typeof target.length === 'number') return Array.prototype.slice.call(target);
    return [];
  }

  function dots(el) {
    return Array.prototype.slice.call(el.querySelectorAll('[data-bpb-dot]'));
  }

  function formatRemaining(el, remaining) {
    if (el.dataset.bpbMode === 'delivery') {
      var symbol = el.dataset.bpbCurrency || '£';
      var major = remaining / 100;
      return symbol + (major % 1 === 0 ? major.toFixed(0) : major.toFixed(2));
    }
    return String(remaining);
  }

  function nextMilestone(el, current) {
    var pending = dots(el).filter(function (dot) {
      return current < num(dot.dataset.bpbValue);
    });
    pending.sort(function (a, b) {
      return num(a.dataset.bpbValue) - num(b.dataset.bpbValue);
    });
    return pending[0] || null;
  }

  function updateContext(el, current) {
    var context = el.querySelector('[data-bpb-context]');
    if (!context) return;

    var next = nextMilestone(el, current);
    if (!next) {
      var completeLine = el.dataset.bpbCompleteLine || '';
      context.textContent = completeLine;
      context.hidden = completeLine === '';
      return;
    }

    var template = el.dataset.bpbContextTemplate || '';
    // No template means the section supplied a static line, so leave it alone.
    if (!template) return;

    var remaining = num(next.dataset.bpbValue) - current;
    var unit = el.dataset.bpbUnit || '';
    var unitPlural = el.dataset.bpbUnitPlural || (unit ? unit + 's' : '');

    var text = template
      .replace('[remaining]', formatRemaining(el, remaining))
      .replace('[unit]', remaining === 1 ? unit : unitPlural)
      .replace('[saving]', next.dataset.bpbSaving || '')
      .replace('[label]', next.dataset.bpbLabel || '')
      .replace('[sublabel]', next.dataset.bpbSublabel || '');

    context.textContent = text.replace(/\s+/g, ' ').trim();
    context.hidden = context.textContent === '';
  }

  /* An equal-gap rail's nodes are not at their proportional positions, so the fill is interpolated
     between the dots' own data-bpb-pos rather than recomputed from the tiers. */
  function positionFor(el, current) {
    var max = num(el.dataset.bpbMax) || 1;
    if (el.dataset.bpbDistribute !== 'equal') return (current / max) * 100;

    var nodes = dots(el)
      .map(function (dot) {
        return { value: num(dot.dataset.bpbValue), pos: num(dot.dataset.bpbPos) };
      })
      .sort(function (a, b) {
        return a.value - b.value;
      });

    if (!nodes.length) return (current / max) * 100;

    var anchorValue = 0;
    var anchorPos = 0;

    for (var i = 0; i < nodes.length; i++) {
      if (current >= nodes[i].value) {
        anchorValue = nodes[i].value;
        anchorPos = nodes[i].pos;
        continue;
      }
      var span = nodes[i].value - anchorValue;
      if (span <= 0) return nodes[i].pos;
      return anchorPos + ((current - anchorValue) / span) * (nodes[i].pos - anchorPos);
    }

    return 100;
  }

  function render(el, current) {
    var percent = Math.max(0, Math.min(100, positionFor(el, current)));

    el.style.setProperty('--bpb-progress', percent.toFixed(2) + '%');
    el.dataset.bpbCurrent = String(current);

    var track = el.querySelector('[role="progressbar"]');
    if (track) track.setAttribute('aria-valuenow', String(current));

    var nodes = el.querySelectorAll('[data-bpb-value]');
    Array.prototype.forEach.call(nodes, function (node) {
      node.dataset.reached = current >= num(node.dataset.bpbValue) ? 'true' : 'false';
    });

    updateContext(el, current);

    el.dispatchEvent(
      new CustomEvent('bronte:progress:update', {
        bubbles: true,
        detail: { current: current, percent: percent }
      })
    );
  }

  window.BronteProgressBar = {
    update: function (target, current) {
      var value = num(current);
      toElements(target).forEach(function (el) {
        render(el, value);
      });
    },

    updateAll: function (current, scope) {
      var root = scope || document;
      this.update(root.querySelectorAll(BAR_SELECTOR), current);
    },

    refresh: function (target) {
      toElements(target).forEach(function (el) {
        render(el, num(el.dataset.bpbCurrent));
      });
    },

    percent: function (el) {
      var bar = toElements(el)[0];
      if (!bar) return 0;
      var max = num(bar.dataset.bpbMax) || 1;
      return Math.max(0, Math.min(100, (num(bar.dataset.bpbCurrent) / max) * 100));
    }
  };
})();
